import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Fab, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Ai } from '@/assets/icons/Ai';
import CrmAiChatPanel from './CrmAiChatPanel';
import { useCrmAiChatUi } from './CrmAiChatContext';
import { MOBILE_BOTTOM_NAV_INSET } from '@/layouts/mobileLayoutConstants';

/**
 * Floating AI chat, shown on CRM pages only. Chat history is client-side per session.
 * Same floating-bubble trigger on desktop and mobile; the mobile offset clears the
 * floating bottom nav pill instead of the desktop sidebar.
 */
const CrmAiChat = () => {
  const { open, toggle, close } = useCrmAiChatUi();
  // Keep the panel mounted after the first open so the conversation survives close/reopen.
  const [everOpened, setEverOpened] = useState(false);
  const location = useLocation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (open) setEverOpened(true);
  }, [open]);

  if (!location.pathname.startsWith('/crm')) return null;

  return (
    <>
      {everOpened && <CrmAiChatPanel open={open} onClose={close} />}
      <Fab
        size="medium"
        onClick={toggle}
        aria-label={open ? 'סגירת עוזר AI' : 'פתיחת עוזר AI'}
        sx={{
          position: 'fixed',
          // The RTL stylis plugin mirrors left/right — `left` renders on the visual right.
          // Desktop offset clears the sidebar (~130px incl. outer padding and gap);
          // mobile has no persistent sidebar, so it sits near the edge instead.
          left: isSmallScreen ? 16 : 110,
          // Desktop clears nothing extra; mobile clears the floating bottom nav pill.
          bottom: isSmallScreen ? `calc(${MOBILE_BOTTOM_NAV_INSET} + 12px)` : 24,
          // Above the sidebar HoverMenu (1300) so the chat stays visible next to the sidebar.
          zIndex: theme.zIndex.modal + 50,
          bgcolor: 'background.paper',
          color: 'primary.main',
          boxShadow: 4,
          '&:hover': { bgcolor: 'grey.100' }
        }}
      >
        {open ? <CloseIcon /> : <Ai />}
      </Fab>
    </>
  );
};

export default CrmAiChat;
